"use client";
import styles from "./Navbar.module.scss";
import { MenuType } from "../../types/baseTypes";
import { NavigationOptionsType } from "@/types/ModuleOptionsType";
import { Menu } from "./Menu/Menu";
import { LanguageToggle } from "./Language/LanguageToggle";
import { useState, useEffect } from "react";
import { Post } from "@aleksundshantu/aunds-deepl-unmute-types/client";

interface NavbarProps {
  menu: MenuType;
  navbarOption: NavigationOptionsType;
  pageData?: Post;
  isHome: boolean;
  logos: JSX.Element;
  search: JSX.Element | false;
  socialMedia: JSX.Element | false;
  hideMenu: boolean;
}

export const NavbarClient = ({
  navbarOption,
  menu,
  pageData,
  isHome,
  logos,
  search,
  socialMedia,
  hideMenu = false,
}: NavbarProps) => {
  const { show_box_shadow, show_search, show_language, show_background } =
    navbarOption.header_menu;
  const [hasBackground, setHasBackground] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      setHasBackground(scrollY > 100);
    };

    // Initial check
    handleScroll();

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      data-has-bg={isHome && !show_background ? hasBackground : true}
      data-show-shadow={show_box_shadow}
      //! please dont remove scrollbar-width class
      className={`${styles["navbar"]} navbar scrollbar-width`}
    >
      {logos}
      <div
        id="navbar-main"
        data-show-search={show_search}
        className={styles["navbar-main"]}
      >
        {!hideMenu && <Menu menu={menu} pageData={pageData} />}
        {socialMedia}
        {!hideMenu && search}
      </div>
      {show_language && pageData && (
        <LanguageToggle addWrapper={true} post={pageData} />
      )}
    </nav>
  );
};
